import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import tags from './tags/sagas'
import products from './products/sagas'
import company from './company/sagas'
import users from './users/sagas'
import groups from './group/sagas'
import project from './project/sagas'
import site from './site/sagas'
import device from './device/sagas'
import tag from './tag/sagas'

export default function* rootSaga() {
  yield all([
    user(),
    menu(),
    settings(),
    tags(),
    products(),
    company(),
    users(),
    groups(),
    project(),
    site(),
    device(),
    tag(),
  ])
}
